import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isShow: false,
    loading: true,
    componentName: '',
    user: {
      account: '',
      // 实名登录显示类型： 0，不显示 1，登录后 2，充值前
      cert_type: 0,
      cert_url: '',
      force_cert_status: 0, // 0 未认证 1已认证未成年 2已认证且已成年
      is_bind: 0,
      // 是否强制实名，1，是 0，否
      is_force_cert: 0,
      // 是否是游客登录
      is_guest: 0,
      passwd: '',
      token: '',
      uid: ''
    },
    protocal_url: '', // 用户隐私协议
    is_agree: false, // 是否同意隐私协议
    guestInfo: { // 游客登录帐密
      guestAccount: '',
      guestPass: ''
    },
    // 需要传递的componentParams
    componentParams: undefined,
    // 打开新页面确认框
    openConfirmShow: false,
    // 需要跳转到的新页面
    openUrl: '',
    changeCompName: '',
    // 显示sdk红包开关
    rebateOpen: false,
    // 红包url
    rebateUrl: '',
    // 客服窗口
    kefu: {
      url: '',
      show: false
    },
    // 控制红包弹窗
    rebatePop: false,
    // 游戏声明
    gameState: false,
    // 游戏声明更新版本
    gameStateVer: '',
    // 切换账号按钮显示
    isHover: false,
    // 保存用户是否实名状态
    isCertName: true,
    pushImgConfig: {}, // sdk推送图片配置
    pushImgShow: false, // 是否展示推送图片配置
    healthBool: false,
    is_open_health: '',
    verticalRb: '', // 竖版红包
    showCopyRight: false,
    changeAccClick: false,
  },
  getters: {
    isForceCert: state => state.user.is_force_cert == 1 || (state.componentParams && state.componentParams.isForceCert)
  },
  mutations: {
    SHOW(state, payload = 'PhoneLogin') {
      const isStringPayload = typeof payload === 'string';
      const componentName = isStringPayload ? payload : payload.name;
      const componentParams = isStringPayload ? undefined : payload.params || {};
      state.isShow = true;
      state.componentName = componentName;
      state.componentParams = componentParams;
    },
    CLOSE(state) {
      state.isShow = false;
    },
    TOGGLE(state, payload = 'Login') {
      const isStringPayload = typeof payload === 'string';
      const componentName = isStringPayload ? payload : payload.name;
      const componentParams = isStringPayload ? undefined : payload.params || {};
      state.isShow = !state.isShow;
      state.componentName = state.isShow ? componentName : '';
      state.componentParams = componentParams;
    },
    SET_USER(state, user = {}) {
      state.user = user;
    },
    SET_PROURL(state, url) {
      state.protocal_url = url;
    },
    SET_COMPNAME(state, name) {
      state.changeCompName = name;
    },
    SET_ISAGREE(state, bool) {
      state.is_agree = bool;
    },
    SET_GUESTINFO(state, info = {}) {
      state.guestInfo = info;
    },
    SHOW_OPENCONFIRM(state, url = '') {
      state.openConfirmShow = true;
      state.openUrl = url;
    },
    CLOSE_OPENCONFIRM(state) {
      state.openConfirmShow = false;
      state.openUrl = '';
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_OPEN(state, openval) {
      state.rebateOpen = openval;
    },
    SET_RABTOPEN(state, openval) {
      state.rebatePop = openval;
    },
    SET_OPENKEFU(state, val = {}) {
      state.kefu = val;
    },
    SET_REBATEURL(state, url) {
      state.rebateUrl = url;
    },
    SET_GAMESTATE(state, bool) {
      state.gameState = bool;
    },
    SET_GAMESTATEVER(state, url) {
      state.gameStateVer = url;
    },
    SET_ISHOVER(state, bool) {
      state.isHover = bool;
    },
    SET_ISCERTNAME(state, bool) {
      state.isCertName = bool;
    },
    SET_PUSHCONFIG(state, val) {
      state.pushImgConfig = val
    },
    SET_PUSHSHOW(state, val) {
      state.pushImgShow = val;
    },
    SET_HEALTH(state, val) {
      state.healthBool = val
    },
    SET_OPEN_HEALTH(state, val) {
      state.is_open_health = val;
    },
    SET_VERTICALRB(state, val) {
      state.verticalRb = val
    },
    SET_COPYRIGHT(state, val) {
      state.showCopyRight = val
    },
    SET_CHANGECLICK(state, bool) {
      state.changeAccClick = bool;
    },
  },
  actions: {},
  modules: {}
});
